<template>
    <tailwind-layout title="Partner Report">
        <div class="space-y-6">
            <BridgeBackLink />
            <header>
                <h1 class="text-2xl font-bold tracking-tight text-rent-risk-blue-400">Partner Report</h1>
                <p class="mt-1 text-sm text-gray-600">Affiliate payouts across all partners, with transfer status.</p>
            </header>
            <div class="overflow-hidden">
            <div class="relative">
                <div class="grid grid-cols-3 sm:grid-cols-2 gap-4 mb-6 sm:flex sm:justify-items-stretch ml-2 lg:ml-0">
                    <div class="sm:w-2/12 pr-4 order-2 sm:order-1">
                        <select v-model="form.paginate" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-100 drop-shadow focus:outline-none focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 sm:text-sm rounded-md">
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <div class="col-span-2 sm:w-8/12 sm:pr-4 order-1 sm:order-2">
                        <input id="search" v-model="form.search" type="text" placeholder="Search..." class="mt-1 shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-gray-100 drop-shadow rounded-md">
                    </div>
                    <div class="sm:w-2/12 order-4 sm:order-4 flex items-start justify-end">

                    </div>
                </div>
            </div>
            <div class="rounded-md lg:shadow shadow-none overflow-x-auto">
                <div class="flex flex-col">
                    <div class="overflow-x-auto">
                        <div class="align-middle inline-block min-w-full">
                            <div class="shadow overflow-hidden lg:border">
                                <input ref="sort_by" type="hidden" v-model="form.sort_by" />
                                <input ref="sort_direction" type="hidden" v-model="form.sort_direction" />
                                <table class="min-w-full divide-y divide-gray-300 hidden lg:table">
                                    <thead class="bg-blue-50">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider">
                                            Name
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-center text-xs font-bold uppercase tracking-wider">
                                            <span @click="sortTable('invoice_date')">
                                                Month
                                                <icon v-show="form.sort_by === 'invoice_date'" :name="form.sort_direction_icon" />
                                                <icon v-if="!form.sort_by || form.sort_by !== 'invoice_date'" :name="'sort'" />
                                            </span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-center text-xs font-bold uppercase tracking-wider">
                                            <span @click="sortTable('total_invoices')">
                                                Total Applications Processed
                                                <icon v-show="form.sort_by === 'total_invoices'" :name="form.sort_direction_icon" />
                                                <icon v-if="!form.sort_by || form.sort_by !== 'total_invoices'" :name="'sort'" />
                                            </span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-center text-xs font-bold uppercase tracking-wider">
                                            <span @click="sortTable('processed_amount')">
                                                Processed Amount
                                                <icon v-show="form.sort_by === 'processed_amount'" :name="form.sort_direction_icon" />
                                                <icon v-if="!form.sort_by || form.sort_by !== 'processed_amount'" :name="'sort'" />
                                            </span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-center text-xs font-bold uppercase tracking-wider">
                                            Transaction ID
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-center text-xs font-bold uppercase tracking-wider">
                                            <span @click="sortTable('processed_date')">
                                                Transaction Date
                                                <icon v-show="form.sort_by === 'processed_date'" :name="form.sort_direction_icon" />
                                                <icon v-if="!form.sort_by || form.sort_by !== 'processed_date'" :name="'sort'" />
                                            </span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-center text-xs font-bold uppercase tracking-wider">
                                            Status
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-center text-xs font-bold uppercase tracking-wider">
                                            Error Message
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(payout, index) in payouts.data" :key="index" class="bg-white hover:bg-gray-100"
                                    >
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {{ payout.partner_name }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                                            {{ payout.month }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                                            {{ payout.total_applications_processed }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                                            <span v-if="payout.transaction_amount">${{ payout.transaction_amount }}</span>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                                            {{ payout.transaction_id }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                                            {{ payout.transaction_date }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-center">
                                            <span
                                                :class="[
                                                'inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold',
                                                payout.status === 'Successful' ? 'bg-green-100 text-green-700' :
                                                payout.status === 'Failed' ? 'bg-red-100 text-red-700' :
                                                payout.status === 'Pending' ? 'bg-yellow-100 text-yellow-700' :
                                                'bg-gray-100 text-gray-600'
                                                ]"
                                            >
                                                {{ payout.status }}
                                            </span>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                                            {{ payout.error_message }}
                                        </td>
                                    </tr>
                                    <tr v-show="!payouts.data.length">
                                        <td colspan="5" class="px-6 py-4 whitespace-nowrap text-dark-gray-400 text-sm font-medium text-center">
                                            No data found.
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <pagination class="mt-6" :links="payouts.links" :results="payouts" :type="'payouts'" />
        </div>
        </div>
    </tailwind-layout>
</template>

<script>
import Icon from '@/Shared/Icon.vue'
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination.vue'
import pickBy from 'lodash/pickBy'
import BridgeBackLink from '@/Shared/BridgeBackLink.vue'

export default {
    components: {
        Icon,
        Pagination,
        TailwindLayout,
        BridgeBackLink
    },
    props: {
        filters: Object,
        payouts: Object,
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                trashed: this.filters.trashed,
                paginate: (this.filters.paginate)?this.filters.paginate:25,
                sort_by: this.filters.sort_by,
                sort_direction_icon : (this.filters.sort_direction === 'desc')?'sort-up':'sort-down'
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function() {
                this.$inertia.get(this.route('reports.partner-report'), pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        sortTable(column) {
            this.form.sort_by = column
            this.form.sort_direction = (this.form.sort_direction === 'desc')?'asc':'desc'
            this.form.sort_direction_icon = (this.form.sort_direction === 'desc')?'sort-up':'sort-down'
        },
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
